import React from "react";

import styled, { keyframes } from "styled-components";

const Wiggle = keyframes`
  0% { transform: rotate(0deg) translate(16px, 0); }
  5% { transform: rotate(2deg) translate(16px, 0); }
  25% { transform: rotate(-2deg) translate(16px, 0); }
  35% { transform: rotate(1deg) translate(16px, 0); }
  45% { transform: rotate(-1deg) translate(16px, 0); }
  60% { transform: rotate(0) translate(16px, 0); }
  100% { transform: rotate(0) translate(16px, 0); }
`;

const TapPawR = keyframes`
  0% { transform: translateY(193px); }
  50% { transform: translateY(190px); }
  70% { transform: translateY(193px); }
  80% { transform: translateY(191px); }
  100% { transform: translateY(193px); }
`;

const TapPawL = keyframes`
  0% { transform: translate(175px, 193px); }
  50% { transform: translate(175px, 191px); }
  70% { transform: translate(175px, 193px); }
  80% { transform: translate(175px, 189px); }
  100% { transform: translate(175px, 193px); }
`;

const Sniff = keyframes`
  0% { transform: translateY(0); }
  10% { transform: translateY(-3px); }
  30% { transform: translateY(0); }
  100% { transform: translateY(0); }
`;

const Spock = styled.svg`
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, -86%);
  width: 100px;
  height: auto;

  .st0 {
    fill: #ffffff;
  }
  .st1 {
    fill: #ffffff;
    stroke: #000000;
    stroke-width: 5.0728;
    stroke-miterlimit: 10;
  }
  .st2 {
    fill: #d8d8d8;
  }
  .st3 {
    fill: #ffffff;
    stroke: #000000;
    stroke-width: 5.073;
    stroke-linecap: round;
    stroke-miterlimit: 10;
  }
  .st4 {
    fill: #fffae6;
  }
  .st5 {
    fill: #e0dace;
  }
  .st6 {
    fill: none;
    stroke: #000000;
    stroke-width: 4.987;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }
  .st7 {
    fill: none;
    stroke: #000000;
    stroke-width: 5.1924;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }
  .st8 {
    fill: #57585b;
  }
  .st9 {
    fill: #aa0000;
    stroke: #000000;
    stroke-width: 5.073;
    stroke-linecap: round;
    stroke-miterlimit: 10;
  }
  .st10 {
    fill: none;
    stroke: #000000;
    stroke-width: 5.073;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }

  #head {
    position: absolute;
    transform-origin: center;
    animation: ${Wiggle} 7s ease-in-out;
    animation-iteration-count: infinite;
  }

  #paw-r {
    position: absolute;
    animation: ${TapPawR} 2.6s ease-in-out;
    animation-iteration-count: infinite;
  }

  #paw-l {
    position: absolute;
    animation: ${TapPawL} 2.5s ease-in-out;
    animation-iteration-count: infinite;
  }

  #nose {
    position: absolute;
    animation: ${Sniff} 2.8s ease-in-out;
    animation-iteration-count: infinite;
  }
`;

export class SpockAnimation extends React.Component {
  render() {
    return (
      <Spock viewBox="0 0 231 239" version="1.1">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none">
          <g id="spock_bone" transform="translate(2.000000, 3.000000)">
            <g id="body" transform="translate(9.000000, 90.000000)">
              <g id={"ear-l"}>
                <path
                  d="M204,90.4 L204,89.3 C204,42.9 159.6,5.2 105.1,5.2 C50.6,5.2 6.2,42.9 6.2,89.3 C6.2,95.3 5.9,100.9 5.7,105.8 C5.3,113.5 5,120.1 5.8,125.6 L200.9,125.6 C204,116.8 204,105.2 204,90.4 Z"
                  id="Path"
                />
                <path
                  d="M3.7,89.3 C3.7,41.5 49.1,2.7 105.1,2.7 C161.1,2.7 206.5,41.5 206.5,89.3 C206.5,104.3 206.6,116.3 203.5,125.6 L206.1,125.6 C209,116.1 209,104.4 209,90.3 L209,89.2 C209,40.1 162.4,0.1 105.1,0.1 C47.8,0.1 1.2,40.1 1.2,89.2 C1.2,95.1 0.9,100.6 0.7,105.5 C0.3,113 5.68434189e-14,119.7 0.8,125.5 L3.3,125.5 C2,116.3 3.7,104.4 3.7,89.3 Z"
                  id="Path"
                  fill="#000000"
                />
              </g>
              <path
                d="M206.5,89.3 C206.5,41.5 161.1,2.7 105.1,2.7 C49.1,2.7 3.7,41.5 3.7,89.3 C3.7,104.3 2,116.3 3.2,125.6 L5.7,125.6 C4.9,120.1 5.2,113.5 5.6,105.8 C5.8,100.9 6.1,95.3 6.1,89.3 C6.1,42.9 50.5,5.2 105,5.2 C159.5,5.2 203.9,42.9 203.9,89.3 L203.9,90.4 C203.9,105.2 203.9,116.8 200.8,125.7 L203.4,125.7 C206.6,116.3 206.5,104.4 206.5,89.3 Z"
                id="Path"
                fill="#000000"
              />
            </g>
            <g id="head" transform="translate(16.000000, 0.000000)">
              <path
                d="M164.9,104.2 C164.9,126.8 161,148.3 173.3,148.3 C185.6,148.3 195.5,122.5 195.5,100 C195.5,77.5 181.7,45.9 167.3,44.6"
                id="Path"
                stroke="#000000"
                strokeWidth="5.0728"
                fill="#FFFFFF"
              />
              <path
                d="M172.9,134.9 C185.2,134.9 190,109.7 190,87.2 C190,85 189.4,78.8 189.2,76.5 C191.8,83.2 193.9,92.9 193.9,98.5 C193.9,121.1 185.8,145.8 173.6,145.8 C167,145.8 167.3,140.1 166.9,130.8 C168.3,133.7 169.4,134.9 172.9,134.9 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M28.3,103.4 C31.8,125.9 47.5,141.5 24.5,148.3 C11.8,152 0.9,122.5 0.9,100 C0.9,77.5 15.6,45.9 30.8,44.6"
                id="Path"
                stroke="#000000"
                strokeWidth="5.0728"
                fill="#FFFFFF"
              />
              <path
                d="M24.9,134.9 C11.9,134.9 6.7,109.7 6.7,87.2 C6.7,85 8.1,76.9 8.4,74.6 C5.6,81.3 2.6,93 2.6,98.5 C2.6,121.1 11.2,145.8 24.2,145.8 C31.2,145.8 31.9,139.6 32.3,130.3 C30.9,133.2 28.6,134.9 24.9,134.9 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M73.7,123.5 C58.7,170.6 59.1,193.4 81.3,202.3 C92,206.6 113,203.6 122.8,198.9 C133.1,194 135.7,182 146.4,177.7"
                id="Path"
                stroke="#000000"
                strokeWidth="5.073"
                fill="#FFFFFF"
                strokeLinecap="round"
              />
              <path
                d="M123.1,192.5 C113.3,197.2 94.5,192.8 83.8,188.5 C63.3,180.3 60.5,165.3 72.2,125 C58.3,169.8 59.3,191.7 80.9,200.4 C91.6,204.7 112.6,201.7 122.4,197 C132.7,192.1 135.3,180.1 146,175.8 L142.1,172.9 C135.8,178.2 131.2,188.6 123.1,192.5 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M189.5,190.3 C196.9,178 181,164 181,164 L184.2,165.1 L192,153.7 C194,146.8 181.3,135.1 175.2,139.5 C169.1,143.9 166.3,147 166.3,147 C161.8,151.2 159.6,154.2 153.5,154.7 C147.3,155.2 140.3,155.6 139.9,155.7 L86.8,159.1 L46.1,159.9 C36.4,160.3 26.8,157.3 19,151.5 C12,146.3 6.5,143.5 2.1,151.5 C-4,162.4 6.8,174 10.5,177.5 L7,191.7 C5.1,198.9 16.1,206.1 22.3,201.3 C28.5,196.5 27.5,195.9 27.5,195.9 C32.1,191.4 34.2,188.2 40.5,187.5 C46.9,186.8 54.2,186.1 54.6,186.1 L102.7,181.5 L147.3,181.1 C156.7,181 165.7,184.2 173.1,190 C179.8,195 185,197.9 189.5,190.3 Z"
                id="Path"
                fill="#FFFAE6"
              />
              <path
                d="M190.1,190 C191.4,187.8 192,185.4 192.1,183.2 C188.3,186 184,183.3 178.8,179.3 C171.4,173.5 162.4,170.4 153,170.4 L108.4,170.8 L60.3,175.4 C59.9,175.4 49.6,174.9 43.2,175.6 C36.8,176.3 30.8,180.4 24.6,185.2 C18.4,190 10.8,188.2 12.7,181 L14.4,169.8 C11.4,167 5.6,156 5.9,147.3 C4.8,148.1 3.8,149.3 2.8,151.1 C-3.3,162 7.5,173.6 11.2,177.1 L7.7,191.3 C5.8,198.5 16.8,205.7 23,200.9 C29.2,196.1 28.2,195.5 28.2,195.5 C32.8,191 34.9,187.8 41.2,187.1 C47.6,186.4 54.9,185.7 55.3,185.7 L103.4,181.1 L148,180.7 C157.4,180.6 166.4,183.8 173.8,189.6 C180.4,194.6 185.5,197.5 190.1,190 Z"
                id="Path"
                fill="#E0DACE"
              />
              <path
                d="M103.4,181 L148,180.6 C157.4,180.5 166.4,183.7 173.8,189.5 C180.4,194.7 185.6,197.5 190.1,190 C197.5,177.7 181.6,163.7 181.6,163.7"
                id="Path"
                stroke="#000000"
                strokeWidth="4.987"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M87.5,158.6 L140.6,155.2 C141,155.2 148,154.7 154.2,154.2 C160.3,153.8 162.5,150.7 167,146.5 C167,146.5 169.8,143.4 175.9,139 C177.5,137.8 179.8,137.7 182.2,138.4 C191.1,140.8 195,151.4 190.1,159.2 L185.5,166.5"
                id="Path"
                stroke="#000000"
                strokeWidth="4.987"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M87.5,158.6 L46.8,159.4 C37.1,159.8 27.5,156.8 19.7,151 C12.7,145.8 7.2,143 2.8,151 C-4.5,164 10.7,177.4 10.7,177.4"
                id="Path"
                stroke="#000000"
                strokeWidth="5.1924"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M103.4,181 L55.3,185.6 C54.9,185.6 47.6,186.4 41.2,187 C34.8,187.7 31.6,191.6 28.2,195.4 C18,206.5 8.6,196.3 7.7,191.2 C6.8,186.1 5.3,176.4 21.2,171.8"
                id="Path"
                stroke="#000000"
                strokeWidth="5.1924"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M172.3,66.3 C172.3,102.8 184.3,136.3 98.3,171.6 C14.3,138.3 24.3,102.7 24.3,66.3 C24.3,29.9 57.4,0.3 98.3,0.3 C139.2,0.3 172.3,29.8 172.3,66.3 Z"
                id="Path"
                stroke="#000000"
                strokeWidth="5.0728"
                fill="#FFFFFF"
              />
              <path
                d="M55.4,104.2 C40.4,151.3 40.8,174.1 63,183 C73.7,187.3 86.8,181.6 98.2,181.5 C109.6,181.6 123.5,179.2 134.2,174.9 C156.4,166 155.9,151.4 140.9,104.2"
                id="Path"
                stroke="#000000"
                strokeWidth="5.073"
                fill="#FFFFFF"
                strokeLinecap="round"
              />
              <path
                d="M102.8,174.8 C91.9,174.9 79.1,178.3 68.8,174.2 C48.6,166.1 47.2,146.1 59.3,105.5 L57.3,105.5 C42.9,150.7 43.3,172.6 64.6,181.2 C74.9,185.3 87.4,179.9 98.4,179.7 C109.3,179.8 122.7,177.4 133,173.3 C133.3,173.2 133.6,172.3 133.9,172.2 C124.3,174.8 112.4,174.9 102.8,174.8 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <g id={"nose"}>
                <path
                  d="M122.4,137.3 C122.4,147.4 111.6,160.5 98.2,160.5 C84.8,160.5 74,148.1 74,138 C74,131 79.3,124.8 87,123 C90.4,122.2 94.2,122.8 98.2,122.8 C102.6,122.8 106.7,122.2 110.2,123 C117.5,124.7 122.4,130.5 122.4,137.3 Z"
                  id="Path"
                  fill="#000000"
                />
                <path
                  d="M89,133.5 C91.8,132.9 94.9,132.9 98.2,132.9 C101.8,132.9 105.2,133 108.1,133.6 C111.6,134.3 114.4,136.1 116.2,138.4 C116.8,139.2 118.2,138.8 118.2,137.9 C118.2,137.9 118.2,137.9 118.2,137.9 C118.2,132.9 114.2,128.7 108.1,127.4 C105.2,126.8 101.8,127.2 98.2,127.2 C94.9,127.2 91.7,126.8 89,127.3 C82.7,128.6 78.3,133.1 78.3,138.3 C78.3,139.2 79.7,139.6 80.2,138.8 C82.1,136.3 85.2,134.3 89,133.5 Z"
                  id="Path"
                  fill="#57585B"
                />
              </g>
              <path
                d="M63,71.5 C63,76.9 61.8,81.4 56.4,81.4 C51,81.4 48.7,77.6 48.7,72.1 C48.7,66.6 52.4,61.7 57.8,61.7 C63.2,61.7 63,66.1 63,71.5 Z"
                id="Path"
                fill="#000000"
              />
              <path
                d="M135,72.1 C135,77.5 136.2,82 141.6,82 C147,82 149.3,78.2 149.3,72.7 C149.3,67.3 145.6,62.3 140.2,62.3 C134.7,62.3 135,66.7 135,72.1 Z"
                id="Path"
                fill="#000000"
              />
              <path
                d="M55,69.8 C54.6,71.8 54.5,73.8 53.5,73.5 C52.1,73.2 52,71.5 52.5,69.5 C52.9,67.5 54,66.1 55.4,66.4 C56.8,66.7 55.4,67.8 55,69.8 Z"
                id="Path"
                fill="#000000"
              />
              <path
                d="M28.5,106 C28.3,110.2 32.3,121.6 35.4,124.9 C36.9,126.5 35.4,129.3 44.8,137.1 C44.9,135.9 47.2,123.5 47.2,123.5 C40.8,123.5 34,115 28.5,106 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M169.1,105.3 C169.3,109.5 166,116.4 165.1,119.5 C164.5,121.6 161.1,129.4 151.7,137.3 C151.6,136.1 149.8,124.5 149.8,124.5 C157.8,122.5 165,113.5 169.1,105.3 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M81.9,184.6 C94.9,196.9 128.5,183 122.4,182.3"
                id="Path"
                stroke="#000000"
                strokeWidth="5.073"
                fill="#AA0000"
                strokeLinecap="round"
              />
              <path
                d="M97.2,186.9 C97.2,188 95.5,187.3 93.5,187.3 C91.5,187.3 90.1,186.8 89.9,186.2 C89.5,185.1 91.5,184.9 93.6,184.9 C95.7,184.9 97.2,185.8 97.2,186.9 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M90.5,186.3 C90.3,187.4 88.8,186.2 87,185.6 C85.1,185 84.2,184.7 84.1,184.1 C84.1,183.7 86.4,183.6 88.2,183.5 C90.2,183.5 90.6,185.2 90.5,186.3 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M103.8,185.8 C104.1,186.9 102.3,186.6 100.4,187.1 C98.5,187.6 96.9,187.5 96.6,187 C96,186.1 97.8,185.3 99.8,184.7 C101.6,184.3 103.5,184.7 103.8,185.8 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M110.2,185.3 C110.5,186.4 108.7,186.1 106.8,186.6 C104.9,187.1 103.3,187 103,186.5 C102.4,185.6 104.2,184.8 106.2,184.2 C108.2,183.6 109.9,184.2 110.2,185.3 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M116.8,183 C117.3,184 115.5,184 113.6,184.9 C111.8,185.8 110.3,185.9 109.9,185.5 C109.1,184.7 110.8,183.6 112.6,182.7 C114.4,181.8 116.3,181.9 116.8,183 Z"
                id="Path"
                fill="#D8D8D8"
              />
              <path
                d="M143.8,71.8 C143.6,70.1 143.2,68.5 144.1,68.4 C145.3,68.3 145.8,69.6 145.9,71.4 C146.1,73.1 145.5,74.6 144.3,74.7 C143.2,74.8 144,73.5 143.8,71.8 Z"
                id="Path"
                fill="#000000"
              />
            </g>
            <g id="paw-l" transform="translate(175.000000, 193.000000)">
              <path
                d="M25.9,40.4 C52.3,40.4 50.7,33.4 51.2,23.8 C51.5,19 50.2,14.2 47.3,10.3 C42.7,4.2 34.8,0.1 25.9,0.1 C17.9,0.1 10.7,3.4 6,8.5 C2.2,12.6 0.4,18.2 0.6,23.8 C0.9,33.4 -1.6,40.4 25.9,40.4 Z"
                id="Path"
                stroke="#000000"
                strokeWidth="5.0728"
                fill="#FFFFFF"
              />
              <path
                d="M15.7,39.2 L15.7,22.7"
                id="Path"
                stroke="#000000"
                strokeWidth="5.073"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M35.1,40 L35.1,22.7"
                id="Path"
                stroke="#000000"
                strokeWidth="5.073"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <g
                transform="translate(2.000000, 20.000000)"
                fill="#D8D8D8"
                id="Path"
              >
                <path d="M30.5,17.6 C23.7,15 21.7,16.6 16.2,12.6 L16.2,17.5 C19.4,17.9 20.4,17.8 25.3,17.8 C28.4,17.8 28.1,17.8 30.5,17.6 Z" />
                <path d="M1.3,0.2 C0.8,2.2 1.1,0.5 1.1,2.6 C1.3,10.4 -1.7,15.2 11.2,17 L11.1,10 C6.8,4.8 5.3,4.3 1.3,0.2 Z" />
              </g>
            </g>
            <g id="paw-r" transform="translate(0.000000, 193.000000)">
              <path
                d="M26.2,40.4 C52.6,40.4 51,33.4 51.5,23.8 C51.8,19 50.5,14.2 47.6,10.3 C43,4.2 35.1,0.1 26.2,0.1 C18.2,0.1 11,3.4 6.3,8.5 C2.5,12.6 0.7,18.2 0.9,23.8 C1.1,33.4 -1.3,40.4 26.2,40.4 Z"
                id="Path"
                stroke="#000000"
                strokeWidth="5.0728"
                fill="#FFFFFF"
              />
              <path
                d="M16,39.2 L16,22.7"
                id="Path"
                stroke="#000000"
                strokeWidth="5.073"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M35.3,40 L35.3,22.7"
                id="Path"
                stroke="#000000"
                strokeWidth="5.073"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <g
                transform="translate(3.000000, 20.000000)"
                fill="#D8D8D8"
                id="Path"
              >
                <path d="M29.8,17.6 C23,15 21,16.6 15.5,12.6 L15.5,17.5 C18.7,17.9 19.7,17.8 24.6,17.8 C27.7,17.8 27.3,17.8 29.8,17.6 Z" />
                <path d="M0.6,0.2 C0.1,2.2 0.4,0.5 0.4,2.6 C0.6,10.4 -2.4,15.2 10.5,17 L10.4,10 C6,4.8 4.6,4.3 0.6,0.2 Z" />
              </g>
            </g>
          </g>
        </g>
      </Spock>
    );
  }
}
